import PickupType from "../../enums/PickupType";
import Game from "../Game";
import GameCore from "../GameCore";
import BasePickup from "./BasePickup";
import PickupGroup from "./PickupGroup";
import WeaponType from "../../enums/WeaponType";
import WEAPONS from "../../consts/WEAPONS";
import { RewardReference } from "../../../handlers/types";
import {
  SPRITESHEET_KEYS,
  SPRITESHEET_FRAMES,
} from "../../consts/SPRITESHEETS";

export default class TreasurePickup extends BasePickup {
  value: number = 0;
  lookId?: string;
  lookChance?: number;
  private isFromFormation: boolean = false;
  private treasureIdAndValue?: RewardReference;

  constructor(group: PickupGroup, x: number, y: number) {
    super(group, x, y, PickupType.TREASURE, SPRITESHEET_KEYS.PICKUPS);
    this.setTexture(
      SPRITESHEET_KEYS.PICKUPS,
      SPRITESHEET_FRAMES.PICKUPS.TREASURE_CHEST
    );
    Game.Core.scene.add.existing(this);
    this.setScale(3.5 * GameCore.PixelScale);
    this.setDepth(this.y - Game.Core.Player.y - this.scene.renderer.height);
  }

  OnRecycle() {
    super.OnRecycle();
    this.setTexture(
      SPRITESHEET_KEYS.PICKUPS,
      SPRITESHEET_FRAMES.PICKUPS.TREASURE_CHEST
    );
  }

  SetTreasureConfig(bossIdAndValue?: RewardReference) {
    // If bossIdAndValue is provided, then it is not from a formation
    this.isFromFormation = !bossIdAndValue;

    if (this.isFromFormation) {
      // Get a treasure ID from the StageService
      this.treasureIdAndValue = Game.Core.StageService.popTreasureId();
    } else {
      // If it is not from a formation, than it is from boss
      // Use the provided boss ID if available, otherwise pop from the array (fallback)
      this.treasureIdAndValue = bossIdAndValue;
    }
  }

  async GetTaken() {
    if (!this.treasureIdAndValue) {
      console.error("⚠️ TreasurePickup: No treasure ID and value found");
      return;
    }

    // Call super.GetTaken() first to mark pickup as inactive and prevent multiple calls
    super.GetTaken();

    // Claim the treasure reward if we have a treasure ID
    const response = await Game.Core.claimTreasureReward(
      this.treasureIdAndValue.id
    );
    // Use the treasure's value
    this.value = this.treasureIdAndValue.value || 0;
    const coinsAmount = this.value;

    // Get upgradeable weapons
    const upgradeableWeapons = Game.Core.Weapons.filter((weapon) => {
      const nextLevel = WEAPONS[weapon.bulletType][weapon.level + 1];
      return nextLevel; // Check if next level exists
    });

    // Randomly upgrade one weapon if available
    let upgradedWeapon: WeaponType | undefined = undefined;
    if (upgradeableWeapons.length > 0) {
      const randomWeapon =
        upgradeableWeapons[
          Math.floor(Math.random() * upgradeableWeapons.length)
        ];
      Game.Core.LevelWeaponUp(randomWeapon.bulletType, false);
      upgradedWeapon = randomWeapon.bulletType;
    }

    Game.Core.SceneManager.EnterTreasure(coinsAmount, upgradedWeapon);

    if (response) {
      Game.Core.PlayerOptions.AddCoins(coinsAmount);
      Game.Core.MainUI.UpdateCoins();
    }
  }
}
